import { logAPI } from "../andyliticsApi";
const webTpaApiUrl = typeof window !== 'undefined' ? window.serverData.data.webTPAUrl : ''; // window is undefined during pre-render
// this needs to be loaded dynamically (since it will change after startup)
//const hpServicesUrl = typeof window !== 'undefined' ? (window.serverData.data.hpServicesSpecificUrl ? window.serverData.data.hpServicesSpecificUrl : window.serverData.data.hpServicesUrl) : ''; // window is undefined during pre-render
import * as tools from "../../helpers/Tools";

export const getCrmMemberMessages = (token, correlationId, sessionId, swhp, memId, startDate, endDate, hpSourceSystem) => {

    //to debug locally, be sure to set the HPGatewayURL value in the app.TST2.config to "http://localhost:59812/api/v1/"
    let url = encodeURI(tools.buildUrl(tools.hpAPIBaseURL(), '/crm/getMemberMessages'));

    //Amisys and HR members will both use the same API route
    if (swhp) {
        var regEx = new RegExp("AMI", "ig");
        url = url.replace(regEx, "HR");
    }

    const params = {
        method: 'post',
        headers: {
            "Authorization": 'bearer ' + token,
            "Content-type": "application/json",
        },
        body: JSON.stringify({
            correlationId: correlationId,
            sessionId: sessionId,
            memberId: memId,
            dateFrom: startDate,
            dateTo: endDate,
            hpSourceSystem: hpSourceSystem
        })
    };
    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.Support.GetCrmMemberMessages", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.Support.GetCrmMemberMessages.Failure", start, url, err); return Promise.reject(err);
    });
};

export const sendCrmMessage = (token, correlationId, sessionId, swhp, memId, msgType, msgDesc, fileName, attachment, caseid, title, mimetype, hpSourceSystem) => {

    //to debug locally, be sure to set the HPGatewayURL value in the app.TST2.config to "http://localhost:59812/api/v1/"
    let url = encodeURI(tools.buildUrl(tools.hpAPIBaseURL(), '/crm/sendMessage'));

    //Amisys and HR members will both use the same API route
    if (swhp) {
        var regEx = new RegExp("AMI", "ig");
        url = url.replace(regEx, "HR");
    }

    const params = {
        method: 'post',
        headers: {
            "Authorization": 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            correlationId: correlationId,
            sessionId: sessionId,
            memberId: memId,
            messageType: msgType,
            messageDescription: msgDesc,
            fileName: fileName,
            attachment: attachment,
            caseid: caseid,
            title: title,
            mimetype: mimetype,
            hpSourceSystem: hpSourceSystem
        })
    };
    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.Support.SendCrmMessage", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.Support.SendCrmMessage.Failure", start, url, err); return Promise.reject(err);
    });
};

export const createCrmTicket = (token, correlationId, sessionId, swhp, memId, msgType, msgDesc, fileName, attachment, title, mimetype, hpSourceSystem) => {

    //to debug locally, be sure to set the HPGatewayURL value in the app.TST2.config to "http://localhost:59812/api/v1/"
    let url = encodeURI(tools.buildUrl(tools.hpAPIBaseURL(), '/crm/createTicket'));

    //Amisys and HR members will both use the same API route
    if (swhp) {
        var regEx = new RegExp("AMI", "ig");
        url = url.replace(regEx, "HR");
    }

    const params = {
        method: 'post',
        headers: {
            "Authorization": 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            correlationId: correlationId,
            sessionId: sessionId,
            memberId: memId,
            messageType: msgType,
            messageDescription: msgDesc,
            fileName: fileName,
            attachment: attachment,
            title: title,
            mimetype: mimetype,
            hpSourceSystem: hpSourceSystem
        })
    };
    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.Support.CreateCrmTicket", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.Support.CreateCrmTicket.Failure", start, url, err); return Promise.reject(err);
    });
};
